<template>
  <z-page class="sales-split">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>搜索：</div>
        <div class="long">
          <el-input
            size="mini"
            class="long"
            v-model="search.text"
            placeholder="关键字搜索"
            suffix-icon="el-icon-search"
          >
            <el-select class="long" v-model="search.text_type" slot="prepend" placeholder="请选择">
              <el-option label="产品名称" :value="1"></el-option>
              <el-option label="套餐名称" :value="2"></el-option>
            </el-select>
          </el-input>
        </div>
      </div>
      <div class="search-item">
        <div>时间：</div>
        <div class="long">
          <el-date-picker
            class="datepicker long"
            v-model="search.start_time"
            size="mini"
            type="month"
            value-format="timestamp"
            format="yyyy-MM "
            placeholder="选择日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </div>
      <div @click="getdata(1)" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
    </div>

    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>时间</div>
        <div>产品名称</div>
        <div>产品套餐</div>
        <div>分成类型</div>
        <div>分成比例/金额</div>
        <div>销售总额</div>
        <div>销售所得</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div style="text-align: center" class="list-item" v-if="data_list.length<=0">暂无数据</div>
        <div v-for="(item, index) in data_list" :key="index" class="list-item">
          <div>{{item.statisticsMonth}}</div>
          <div>{{ item.productName }}</div>
          <div>{{ item.mealName }}</div>
          <div>{{ item.saleDeptCostType|saleDeptCostType}}</div>
          <div>{{ item.saleDeptCostRate|fix}}{{(item.saleDeptCostType=='0'||item.saleDeptCostType=='2')?'%':(item.saleDeptCostType=='1'?'元':'')}}</div>
          <div>{{ item.actualPayMoney |fix}}</div>
          <div>{{ item.saleDeptRoyalty |fix}}</div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <z-pagination
      @sizeChange="getdata()"
      @pageChange="handleCurrentChange"
      :current-page.sync="nowPage"
      :page-size="10"
      :total="total"
    ></z-pagination>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: {
        text:'',
        text_type:null,
        start_time: ''
      },
      data_list: [],
      nowPage: 1,
      total: 0,
      // 限制时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created() {
    this.getdata(1);
  },
  methods: {
    clearsearch() {
      this.search.text_type=''
      this.search.text=''
      this.search.start_time= ''
      this.getdata(1);
    },
    //获取数据方法
    getdata(num) {
      this.nowPage=num||this.nowPage
      this.loading = true;
      let url = `/api/supplier/get/sale/dept/royalty/statistics`;
      this.$http
        .get(url, {
          params: {
            search_type: this.search.text_type,
            statistics_month: this.$func
              .myTimeToLocal(this.search.start_time)
              .substring(0, 7)||undefined, // 时间
            page: num || this.nowPage, // 页码
            key_word: this.search.text || null //  产品名称
          }
        })
        .then(res => {
          if (res.code == "200") {
            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 页面改变
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getdata();
    }
  }
};
</script>

<style lang="less" scoped>
.sales-split {
  .list-head,
  .list-item {
    > div {
      width: 13.33%;
      &:nth-child(3) {
        width: 20%;
      }
    }
  }
}
</style>